import httpClient from '@/http-client'

export const formModel = (options = {}) => {
  return httpClient
    .get('/api/v1/address/form-view-models', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getDistrict = (Options = {}) => {
  return httpClient
    .get('/api/v1/address/districts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const district = data => {
  return httpClient
    .post('/api/v1/address/districts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCommune = (Options = {}) => {
  return httpClient
    .get('/api/v1/address/communes', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const communeExcel = data => {
  return httpClient
    .post('/api/v1/address/communes/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const commune = data => {
  return httpClient
    .post('/api/v1/address/communes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getVillage = (Options = {}) => {
  return httpClient
    .get('/api/v1/address/villages', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const village = data => {
  return httpClient
    .post('/api/v1/address/villages', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const updateCommune = (code, data) => {
  return httpClient
    .put(`/api/v1/address/communes/${code}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getDistrict,
  district,
  commune,
  getCommune,
  getVillage,
  village,
  formModel,
  communeExcel,
  updateCommune
}
